var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submenubarDoc"},[_c('h1',{staticClass:"medium-title warning-mobile"},[_vm._v("Submenu bar only showing in mobile screen.")]),_c('saved-card',{attrs:{"listUrl":_vm.urlList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }